import { LitElement, html, css, unsafeHTML } from 'https://cdn.jsdelivr.net/gh/lit/dist@3/all/lit-all.min.js'

/** Phosphor icon paths (matches snippets/icons.liquid) for subscription USPs */
const SKIO_USP_ICON_PATHS = {
  tag: '<path d="M3.30781 10.8078C3.19082 10.6907 3.12508 10.5319 3.125 10.3664V3.125H10.3664C10.5319 3.12508 10.6907 3.19082 10.8078 3.30781L18.5672 11.0672C18.6843 11.1844 18.7501 11.3433 18.7501 11.509C18.7501 11.6747 18.6843 11.8336 18.5672 11.9508L11.9531 18.5672C11.8359 18.6843 11.677 18.7501 11.5113 18.7501C11.3456 18.7501 11.1867 18.6843 11.0695 18.5672L3.30781 10.8078Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.5625 7.5C7.08027 7.5 7.5 7.08027 7.5 6.5625C7.5 6.04473 7.08027 5.625 6.5625 5.625C6.04473 5.625 5.625 6.04473 5.625 6.5625C5.625 7.08027 6.04473 7.5 6.5625 7.5Z" fill="currentColor"/>',
  'calendar-blank':
    '<path d="M16.25 3.125H3.75C3.40482 3.125 3.125 3.40482 3.125 3.75V16.25C3.125 16.5952 3.40482 16.875 3.75 16.875H16.25C16.5952 16.875 16.875 16.5952 16.875 16.25V3.75C16.875 3.40482 16.5952 3.125 16.25 3.125Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.75 1.875V4.375" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.25 1.875V4.375" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.125 6.875H16.875" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>',
  check: '<path d="M16.875 5.625L8.125 14.375L3.75 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>',
  truck:
    '<path d="M14.375 6.25H17.7016C17.8261 6.24994 17.9478 6.28709 18.0511 6.35669C18.1544 6.42629 18.2345 6.52517 18.2812 6.64063L19.375 9.375" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M1.875 11.25H14.375" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15 16.875C16.0355 16.875 16.875 16.0355 16.875 15C16.875 13.9645 16.0355 13.125 15 13.125C13.9645 13.125 13.125 13.9645 13.125 15C13.125 16.0355 13.9645 16.875 15 16.875Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.25 16.875C7.28553 16.875 8.125 16.0355 8.125 15C8.125 13.9645 7.28553 13.125 6.25 13.125C5.21447 13.125 4.375 13.9645 4.375 15C4.375 16.0355 5.21447 16.875 6.25 16.875Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.125 15H8.125" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M14.375 9.375H19.375V14.375C19.375 14.5408 19.3092 14.6997 19.1919 14.8169C19.0747 14.9342 18.9158 15 18.75 15H16.875" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M4.375 15H2.5C2.33424 15 2.17527 14.9342 2.05806 14.8169C1.94085 14.6997 1.875 14.5408 1.875 14.375V5.625C1.875 5.45924 1.94085 5.30027 2.05806 5.18306C2.17527 5.06585 2.33424 5 2.5 5H14.375V13.232" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>',
  package:
    '<path d="M10 10.0859V18.1234" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M2.55469 6.00977L10 10.0848L17.4453 6.00977" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.175 14.2849L10.3 18.049C10.208 18.0993 10.1049 18.1257 10 18.1257C9.89515 18.1257 9.79198 18.0993 9.7 18.049L2.825 14.2849C2.72683 14.2312 2.64488 14.1521 2.58772 14.0559C2.53055 13.9597 2.50025 13.8499 2.5 13.738V6.2646C2.50025 6.1527 2.53055 6.04291 2.58772 5.94672C2.64488 5.85052 2.72683 5.77144 2.825 5.71772L9.7 1.95366C9.79198 1.90333 9.89515 1.87695 10 1.87695C10.1049 1.87695 10.208 1.90333 10.3 1.95366L17.175 5.71772C17.2732 5.77144 17.3551 5.85052 17.4123 5.94672C17.4695 6.04291 17.4997 6.1527 17.5 6.2646V13.7365C17.5 13.8486 17.4699 13.9587 17.4127 14.0552C17.3555 14.1517 17.2734 14.2311 17.175 14.2849Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.37109 3.77344L13.7492 7.81172V11.8742" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>',
  'currency-circle-dollar':
    '<path d="M10 5.625V6.875" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M10 13.125V14.375" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.125 13.125H10.9375C11.3519 13.125 11.7493 12.9604 12.0424 12.6674C12.3354 12.3743 12.5 11.9769 12.5 11.5625C12.5 11.1481 12.3354 10.7507 12.0424 10.4576C11.7493 10.1646 11.3519 10 10.9375 10H9.0625C8.6481 10 8.25067 9.83538 7.95765 9.54235C7.66462 9.24933 7.5 8.8519 7.5 8.4375C7.5 8.0231 7.66462 7.62567 7.95765 7.33265C8.25067 7.03962 8.6481 6.875 9.0625 6.875H11.875" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>',
  gift:
    '<path d="M16.875 6.25H3.125C2.77982 6.25 2.5 6.52982 2.5 6.875V9.375C2.5 9.72018 2.77982 10 3.125 10H16.875C17.2202 10 17.5 9.72018 17.5 9.375V6.875C17.5 6.52982 17.2202 6.25 16.875 6.25Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.25 10V15.625C16.25 15.7908 16.1842 15.9497 16.0669 16.0669C15.9497 16.1842 15.7908 16.25 15.625 16.25H4.375C4.20924 16.25 4.05027 16.1842 3.93306 16.0669C3.81585 15.9497 3.75 15.7908 3.75 15.625V10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M10 6.25V16.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.8117 2.43849C14.5414 3.16818 14.5844 4.39631 13.8117 5.08068C12.4906 6.25021 10 6.25021 10 6.25021C10 6.25021 10 3.75959 11.1719 2.43849C11.8539 1.66584 13.082 1.70881 13.8117 2.43849Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.18849 2.43849C5.45881 3.16818 5.41584 4.39631 6.18849 5.08068C7.50959 6.25021 10.0002 6.25021 10.0002 6.25021C10.0002 6.25021 10.0002 3.75959 8.82834 2.43849C8.14631 1.66584 6.91818 1.70881 6.18849 2.43849Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>',
  heart:
    '<path d="M10 17.5C10 17.5 1.875 13.125 1.875 7.96875C1.875 6.84987 2.31947 5.77681 3.11064 4.98564C3.90181 4.19447 4.97487 3.75 6.09375 3.75C7.85859 3.75 9.37031 4.71172 10 6.25C10.6297 4.71172 12.1414 3.75 13.9062 3.75C15.0251 3.75 16.0982 4.19447 16.8894 4.98564C17.6805 5.77681 18.125 6.84987 18.125 7.96875C18.125 13.125 10 17.5 10 17.5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>',
  lightning:
    '<path d="M12.5 1.25L11.25 7.5L16.25 9.375L7.5 18.75L8.75 12.5L3.75 10.625L12.5 1.25Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>',
  'bell-ringing':
    '<path d="M7.5 15C7.5 15.663 7.76339 16.2989 8.23223 16.7678C8.70107 17.2366 9.33696 17.5 10 17.5C10.663 17.5 11.2989 17.2366 11.7678 16.7678C12.2366 16.2989 12.5 15.663 12.5 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M14.375 1.875C15.5819 2.64509 16.5608 3.72406 17.2102 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M2.78906 5C3.43841 3.72406 4.41731 2.64509 5.62422 1.875" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M4.37515 8.75C4.37515 7.25816 4.96778 5.82742 6.02267 4.77252C7.07756 3.71763 8.5083 3.125 10.0001 3.125C11.492 3.125 12.9227 3.71763 13.9776 4.77252C15.0325 5.82742 15.6251 7.25816 15.6251 8.75C15.6251 11.5484 16.2736 13.1719 16.7892 14.0625C16.844 14.1574 16.8728 14.2649 16.8729 14.3745C16.873 14.484 16.8444 14.5916 16.7898 14.6865C16.7352 14.7815 16.6566 14.8604 16.5619 14.9154C16.4672 14.9705 16.3597 14.9996 16.2501 15H3.75015C3.64076 14.9993 3.53345 14.97 3.43896 14.9149C3.34448 14.8597 3.26611 14.7808 3.2117 14.6859C3.15729 14.591 3.12874 14.4835 3.12891 14.3741C3.12907 14.2647 3.15795 14.1572 3.21265 14.0625C3.72749 13.1719 4.37515 11.5477 4.37515 8.75Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>',
  'map-pin':
    '<path d="M10 10.625C11.3808 10.625 12.5 9.50575 12.5 8.125C12.5 6.74429 11.3808 5.625 10 5.625C8.61925 5.625 7.5 6.74429 7.5 8.125C7.5 9.50575 8.61925 10.625 10 10.625Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.25 8.125C16.25 13.75 10 18.125 10 18.125C10 18.125 3.75 13.75 3.75 8.125C3.75 6.46740 4.40848 4.87768 5.58058 3.70558C6.75268 2.53348 8.34242 1.875 10 1.875C11.6576 1.875 13.2473 2.53348 14.4194 3.70558C15.5915 4.87768 16.25 6.46740 16.25 8.125Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>',
  smiley:
    '<path d="M10.5859 17.7998C14.7281 17.7998 18.0859 14.4419 18.0859 10.2998C18.0859 6.15767 14.7281 2.7998 10.5859 2.7998C6.4438 2.7998 3.08594 6.15767 3.08594 10.2998C3.08594 14.4419 6.4438 17.7998 10.5859 17.7998Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.77344 9.6748C8.2912 9.6748 8.71094 9.25507 8.71094 8.7373C8.71094 8.21954 8.2912 7.7998 7.77344 7.7998C7.25567 7.7998 6.83594 8.21954 6.83594 8.7373C6.83594 9.25507 7.25567 9.6748 7.77344 9.6748Z" fill="currentColor"/><path d="M13.3984 9.6748C13.9162 9.6748 14.3359 9.25507 14.3359 8.7373C14.3359 8.21954 13.9162 7.7998 13.3984 7.7998C12.8807 7.7998 12.4609 8.21954 12.4609 8.7373C12.4609 9.25507 12.8807 9.6748 13.3984 9.6748Z" fill="currentColor"/><path d="M13.7109 12.1748C13.0625 13.2959 11.9742 14.0498 10.5859 14.0498C9.19766 14.0498 8.10938 13.2959 7.46094 12.1748" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>',
  location:
    '<path d="M4.375 18.125H15.625" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M10 10.625C11.3807 10.625 12.5 9.50571 12.5 8.125C12.5 6.74429 11.3807 5.625 10 5.625C8.61929 5.625 7.5 6.74429 7.5 8.125C7.5 9.50571 8.61929 10.625 10 10.625Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.25 8.125C16.25 13.75 10 18.125 10 18.125C10 18.125 3.75 13.75 3.75 8.125C3.75 6.4674 4.40848 4.87769 5.58058 3.70558C6.75269 2.53348 8.3424 1.875 10 1.875C11.6576 1.875 13.2473 2.53348 14.4194 3.70558C15.5915 4.87769 16.25 6.4674 16.25 8.125Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>',
  clock:
    '<path d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M10 5.625V10H14.375" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>',
}

/**
 * Skio Universal Plan Picker
 * @docs https://integrate.skio.com/
 *
 * Uses LitJS (<5kb) https://lit.dev/ for reactive web components
 */

const SKIO_CSS_VARS = [
  '--skio-group-border-radius',
  '--skio-group-border-width',
  '--skio-group-border-color',
  '--skio-group-border-selected-color',
  '--skio-group-background-color',
  '--skio-group-background-selected-color',
  '--skio-group-text-color',
  '--skio-group-text-selected-color',
  '--skio-discount-color',
  '--skio-discount-text-color',
  '--skio-button-plan-selector-width',
  '--skio-tooltip-background-color',
  '--skio-tooltip-text-color',
  '--skio-usp-color',
];

const isTransparentCssColor = (value) => {
  if (!value || !value.trim()) return true;
  const normalized = value.trim().toLowerCase().replace(/\s/g, '');
  return (
    normalized === 'transparent' ||
    normalized === 'rgba(0,0,0,0)' ||
    normalized.endsWith(',0)')
  );
};

export class SkioPlanPicker extends LitElement {
  static properties = {
    key: { type: String },

    product: { type: Object },
    productHandle: { type: String },
    selectedVariant: { type: Object },

    options: { type: Object },

    moneyFormat: { type: String },
    variantDeliveryInfo: { type: Object },

    quantity: { type: Number },
    rules: { type: Array },
    rule: { type: Object },
    cart: { type: Object },

    availableSellingPlanGroups: { state: true },
    selectedSellingPlanGroup: { type: Object },
    selectedSellingPlan: { type: Object },

    tooltipContent: { type: String },
    disableUrl: { type: Boolean },

    debug: { type: Boolean },

    colorScheme: { type: String },
  }

  static styles = [
    css`
      :host {
        width: 100%;
      }

      .skio-plan-picker {
        display: flex;
        gap: 1rem;
        padding: 0;
        border: 0;
        font-size: 15px;
        color: rgb(var(--color-foreground));
        width: 100%;
        margin-bottom: 1rem;
        font-family: inherit;

        text-align: left;
      }

      .skio-delivery-info {
        margin-bottom: 0.75rem;
        font-size: 12px;
        line-height: 1.4;
        color: rgb(var(--color-foreground));
        text-align: right;
        min-height: 17px;
      }

      .skio-delivery-info p {
        margin: 0;
      }

      :host([layout='hidden']) .skio-plan-picker {
        display: none;
      }

      :host([layout='vertical']) .skio-plan-picker {
        flex-direction: column;
      }

      :host([layout='horizontal']) .skio-plan-picker {
        flex-direction: row;
        flex-wrap: wrap;
      }

      :host([skio-block]) .skio-delivery-info {
        display: none;
      }

      .sr-only {
        position: absolute;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        width: 1px;
        height: 1px;
        margin: -1px;
        padding: 0;
        border: 0;
      }

      .group-container {
        display: block;
        position: relative;
        transition: border-color 0.2s ease;
        /* Use theme CSS variables - they cascade from parent color scheme classes */
        border: var(--skio-group-border-width, 1px) solid var(--skio-group-border-color, rgb(var(--color-border)));
        border-radius: var(--skio-group-border-radius, 0);
        background-color: var(--skio-group-background-color, rgb(var(--color-background)));
        color: var(--skio-group-text-color, rgb(var(--color-foreground)));
      }

      :host([skio-block]) .group-container {
        color: var(--skio-group-text-color, #000);
      }

      .group-container--selected {
        border-color: var(--skio-group-border-selected-color, rgb(var(--color-primary)));
        background-color: var(--skio-group-background-selected-color, rgb(var(--color-secondary-background)));
        color: var(--skio-group-text-selected-color, rgb(var(--color-foreground)));
      }

      :host([skio-block]) .group-container--selected {
        color: var(--skio-group-text-selected-color);
        background-color: var(--skio-group-background-selected-color);
      }

      :host([skio-block]) .group-container__badge {
        background-color: var(--skio-discount-color, rgb(var(--color-primary)));
        color: var(--skio-discount-text-color, rgb(var(--color-foreground)));
      }

      .group-container--last {
        order: 1;
      }

      .group-container--has-badge {
        margin-top: 12px;
      }

      .group-container__badge {
        position: absolute;
        top: 0;
        left: 10px;
        transform: translateY(-50%);
        z-index: 1;
        display: inline-flex;
        align-items: center;
        gap: 5px;
        padding: 5px 10px 4px;
        border-radius: 4px;
        background-color: var(--skio-group-border-selected-color, rgb(var(--color-primary)));
        color: var(--skio-discount-text-color, rgb(var(--color-foreground)));
        text-shadow: 0 0 1px var(--skio-group-text-color, rgb(var(--color-primary)));
        font-size: 11px;
        font-weight: 700;
        line-height: 1;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        white-space: nowrap;
      }

      .group-container__badge svg {
        flex-shrink: 0;
        color: #fff;
      }

      :host([layout='horizontal']) .group-container {
        width: calc(50% - 0.5rem - calc(2 * var(--skio-group-border-width, 1px)));
      }

      .group-input {
        position: absolute;
        opacity: 0;
        width: 0px;
        height: 0px;
      }

      .group-input:focus-visible ~ .group-label {
        outline: 2px rgb(var(--color-border)) solid;
        outline-offset: 4px;
      }

      .group-label {
        display: flex;
        flex-direction: column;
        padding: 10px;
        cursor: pointer;
      }

      .group-topline {
        display: flex;
        align-items: center;
        width: 100%;

        gap: 8px;
      }

      .group-container--selected .group-topline {
        font-weight: 400;
      }

      :host([layout='horizontal']) .group-topline {
        flex-direction: column;
        text-align: center;
      }

      // .skio-radio__container {
      //   display: flex;
      //   color: var(--skio-group-border-color, rgb(var(--color-border)));
      // }

      // .group-container--selected .skio-radio__container {
      //   color: var(--skio-group-border-selected-color, rgb(var(--color-primary)));
      // }

      .skio-radio {
        transform-origin: center;
        opacity: 0;
        transform: scale(0);
        transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
      }

      .group-label:hover .skio-radio {
        opacity: 0.75;
        transform: scale(1);
      }

      .group-container--selected .group-label .skio-radio {
        opacity: 1;
        transform: scale(1);
      }

      .skio-price {
        display: flex;
        justify-content: flex-end;
        flex-wrap: wrap;
        align-items: center;
        text-align: right;
        gap: 8px;

        line-height: 1;

        margin-left: auto;
        vertical-align: middle;

        font-weight: 400;
        font-size: 18px;
        flex-direction: column;
        align-items: flex-end;
      }

      /* Theme settings: Colors → Sale badge (color_badge_sale); only the main amount, not Was / unit */
      .skio-price__current--sale {
        color: var(--color-badge-sale);
      }

      .skio-price s {
        font-size: 1.2rem;
        font-weight: 400;
        opacity: 0.7;
      }

      .skio-unit-price {
        font-size: 1.2rem;
        font-weight: 400;
      }

      :host([layout='horizontal']) .skio-price {
        text-align: center;
        margin-right: auto;
      }

      .group-content {
        display: flex;
        flex-direction: column;
        opacity: 1;
        width: auto;
        max-height: 1000px;
        transition: max-height 0.15s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        margin-top: .5rem;
      }

      .group-content.margin-left {
        margin-left: 25px;
      }

      .group-content p {
        margin: 0.5rem 0 0 0;
        font-size: 13px;
        color: rgb(var(--color-foreground));
      }

      :host([layout='horizontal']) .group-content {
        width: 100%;
        order: 2;
      }

      /* Hide frequency if not selected */
      .group-container:not(.group-container--selected) .group-content {
        pointer-events: none;
        opacity: 0;
        max-height: 0;
        visibility: hidden;
      }

      :host([layout='horizontal']) .group-container:not(.group-container--selected) + .group-content {
        pointer-events: none;
        opacity: 0;
        max-height: 0;
        visibility: hidden;
      }

      .group-title {
        width: 100%;
        max-width: 60%;
        line-height: 1.5;
        position: relative;
        font-size: .9em;

        .group-title-inner {
          // display: flex;
          gap: .5em;
          align-items: center;
        }
      }

      :host([layout='horizontal']) .group-title {
        max-width: 100%;
      }
      
      .savings {
        color: var(--skio-discount-text-color, rgb(var(--color-foreground)));
      }

      .savings.bubble {
        padding: 5px 8px 4px 8px;
        background-color: var(--skio-discount-color, rgb(var(--color-primary)));
        border: 1px var(--skio-discount-color, rgb(var(--color-primary))) solid;
        border-radius: 4px;
        font-size: .9em;
        color: var(--skio-discount-text-color, rgb(var(--color-background)));
        white-space: nowrap;
      }

      .skio-tooltip {
        position: relative;
        display: inline-block;
        cursor: pointer;
        margin-left: 5px;
      }

      .skio-tooltip svg {
        vertical-align: middle;
      }

      .skio-tooltip-text {
        visibility: hidden;
        opacity: 0;
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        background-color: var(--skio-tooltip-background-color, rgb(var(--color-foreground)));
        color: var(--skio-tooltip-text-color, rgb(var(--color-background)));
        padding: 5px 10px;
        border-radius: 5px;
        font-size: 12px;
        white-space: normal;
        width: 200px;
        z-index: 1000;
        transition: opacity 0.3s ease;
      }

      .skio-tooltip:hover .skio-tooltip-text,
      .skio-tooltip:focus-within .skio-tooltip-text {
        visibility: visible;
        opacity: 1;
      }

      .selling-plan-dropdown {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        display: flex;
        align-items: center;
        gap: 5px;
        width: 100%;
        margin-top: 5px;
        padding: 8px 30px 8px 10px;
        background-color: #fafafa; 
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='h-6 w-6' fill='none' viewBox='0 0 24 24' stroke='currentColor' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7' /%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 10px top 50%;
        background-size: 16px;
        border: 1px solid;
        border-color: var(--skio-group-text-selected-color, rgb(var(--color-foreground)));
        border-radius: calc(var(--skio-group-border-radius) / 2);
        font-size: .9em;
        color: var(--skio-group-text-selected-color, rgb(var(--color-foreground)));
        text-overflow: ellipsis;
        white-space: nowrap;
        outline:none !important;
        font-family: inherit;
      }

      :host([skio-block]) .selling-plan-dropdown {
        background-color: transparent;
        border-color: #000;
      }

      .selling-plan-dropdown-label {
        font-weight: 400;
      }

      .selling-plan-dropdown--one {
        background-image: none;
        pointer-events: none;
        background: transparent;
      }

      .selling-plan-buttons {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(var(--skio-button-plan-selector-width, 20px), 1fr));
        gap: 10px;
        padding: 0.75rem 0;
        border: 0;
        font-size: 13px;
      }

      .selling-plan-buttons input[type='radio'] {
        position: absolute;
        opacity: 0;
        width: 0;
        height: 0;
      }

      .selling-plan-buttons label {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border: 1px solid rgb(var(--color-border));
        text-align: center;
        padding: 1rem 0.5rem;
      }

      .selling-plan-buttons input[type='radio']:checked + label {
        border-color: rgb(var(--color-foreground));
      }

      .selling-plan-buttons input:focus-visible + label {
        outline: 2px rgb(var(--color-border)) solid;
        outline-offset: 4px;
      }

      .group-content-additional {
        /* margin-top: 5px; */
        font-size: 13px;
        font-weight: 400;
      }

      .skio-usps {
        display: flex;
        align-items: stretch;
        margin-top: .5rem;
        color: var(--skio-usp-color, rgb(var(--color-foreground)));
      }

      .skio-usp {
        flex: 1;
        display: flex;
        align-items: center;
        gap: 8px;
        min-width: 0;
        padding: 0 8px;
        font-size: 11px;
        line-height: 1.35;
        font-weight: 500;
      }

      .skio-usp:first-child {
        padding-left: 0;
      }

      .skio-usp:last-child {
        padding-right: 0;
      }

      .skio-usp:not(:last-child) {
        border-right: 1px solid rgba(0, 0, 0, 0.1);
      }

      .skio-usp__icon {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        background: #fff;
        border: 1px solid rgba(0, 0, 0, 0.08);
        color: var(--skio-usp-color, currentColor);
      }

      .skio-usp__icon svg {
        display: block;
        width: 14px;
        height: 14px;
      }

      .skio-usp__icon svg path[stroke] {
        stroke: currentColor;
      }

      .skio-usp__icon svg path[fill]:not([fill='none']) {
        fill: currentColor;
      }

      .skio-usp__text {
        min-width: 0;
      }

      :host([layout='horizontal']) .skio-usps {
        flex-direction: column;
        gap: 8px;
      }

      :host([layout='horizontal']) .skio-usp {
        border-right: none;
        padding: 0;
      }

      .skio-details {
        --text-color: #333;
        --text-color-secondary: #888;

        user-select: none;
        -webkit-user-select: none;
        margin-bottom: 20px;
        order: 3;
        max-width: max-content;
      }

      .skio-details summary::-webkit-details-marker,
      .skio-details summary::marker,
      .skio-details slot {
        color: rgba(0, 0, 0, 0) !important;
      }

      .skio-details summary {
        margin-top: 15px;
      }

      .skio-details summary span {
        font-size: 0.9em;
        display: flex;
        padding: 0.5em 0;
        cursor: pointer;
        align-items: center;
        gap: 10px;
        text-decoration: underline;

        margin-top: -40px;
        color: rgb(var(--color-foreground));
      }

      @keyframes fadeInDown {
        0% {
          opacity: 0;
          transform: translateY(-15px);
        }
        100% {
          opacity: 1;
          transform: translateY(0px);
        }
      }
      .skio-details[open] > .skio-details--content {
        animation-name: fadeInDown;
        animation-duration: 0.3s;
      }

      .skio-details--content {
        position: absolute;
        z-index: 1020;
        padding: 1em;
        width: fit-content;
        border-radius: 5px;
        background: rgb(var(--color-background));
        box-shadow: 0 0 5px rgb(23 24 24 / 5%), 0 1px 2px rgb(0 0 0 / 7%);
      }

      .skio-details ul {
        margin: 0;
        padding: 0;
      }

      .skio-details ul li {
        display: flex;
        align-items: flex-start;
        gap: 0.75em;

        margin-bottom: 1em;
      }

      .skio-details .skio-content {
        display: flex;
        flex-direction: column;
      }

      .skio-details .skio-content p {
        font-size: 0.9em;

        margin-top: 0;
        margin-bottom: 0;

        letter-spacing: 0;
        line-height: 1.5;

        color: var(--text-color);
      }

      .skio-details ul li small {
        font-size: 0.7em;
        color: var(--text-color-secondary);
      }

      .skio-details .skio-icon {
        display: flex;

        width: 2.25em;
        height: 2.25em;

        color: var(--text-color);
        background: #f8f8f8;
        border-radius: 100%;

        flex-shrink: 0;
        align-items: center;
        justify-content: center;
      }

      .skio-details .skio-icon svg {
        width: 1.25em;
        height: 1.25em;

        color: inherit;
      }

      .skio-details--footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 0.9em;
      }

      .skio-details--footer a {
        color: var(--text-color);
      }

      .skio-manage-link {
        text-decoration: underline;
      }

      .powered-by-skio {
        font-size: 0.8em;

        display: flex;
        text-decoration: none;

        align-items: center;
        gap: 3px;
      }

      .setupMode {
        position: relative;
        color: black;
        padding: 1rem;
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-bottom: 1rem;
        font-size: 14px;
        border-style: solid;
        border-width: 4px;
        border-image: repeating-linear-gradient(-55deg, #000, #000 20px, #ffb101 20px, #ffb101 40px) 10;
      }

      .setupMode:after {
        content: 'Setup Mode';
        position: absolute;
        top: 0;
        right: 0;
        background-color: black;
        color: white;
        padding: 0.25rem 1rem;
        font-size: 13px;
      }

      .setupMode .detection {
        display: grid;
        grid-template-columns: auto 1fr;
        gap: 10px;
      }

      .setupMode .detection small {
        grid-column: 1/-1;
      }
    `,
  ]

  constructor() {
    super()

    // Start - Debug Variables
    this.debug = this.debug || window?.Shopify?.designMode
    this.variantChanged = false
    // End - Debug Variables

    this.rules = []
    this.rule = null
    this.quantity = 1
    this.showDetailsHover = false
    this.variantDeliveryInfo = {}
  }

  async connectedCallback() {
    super.connectedCallback()

    this.log('Mounted')

    this.loadVariantDeliveryInfo()

    // Apply color scheme if provided
    this.applyColorScheme()

    if (this.productHandle) {
      this.loading = true
      this.fetchProduct(this.productHandle)
    }

    this.bindFormEvents()
    this.bindCartEvents()

    this.rules = await this.fetchRules()
    await this.getRule()

    // Initialize sticky bar form if it exists
    this.updateStickyBarForm()

    // Watch for sticky bar form to appear dynamically
    this.observeStickyBarForm()
  }

  // SECTION: Element Templates
  radioTemplate() {
    return html`
      <div class="skio-radio__container">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1"></circle>
          <circle class="skio-radio" cx="12" cy="12" r="7" fill="currentColor"></circle>
        </svg>
      </div>
    `
  }

  subscriptionBadgeText() {
    const text = this.options?.subscription_badge_text
    if (!text) return ''
    return text.replace(/<[^>]*>/g, '').trim()
  }

  subscriptionBadgeTemplate() {
    const text = this.subscriptionBadgeText()
    if (!text) return ''

    return html`
      <div class="group-container__badge">
        <svg width="10" height="10" viewBox="0 0 12 12" aria-hidden="true">
          <path d="M6 0L7.854 4.146L12 6L7.854 7.854L6 12L4.146 7.854L0 6L4.146 4.146L6 0Z" fill="currentColor"></path>
        </svg>
        ${unsafeHTML(this.options.subscription_badge_text)}
      </div>
    `
  }

  subscriptionUsps() {
    return [1, 2, 3]
      .map(index => ({
        icon: this.options?.[`usp_${index}_icon`],
        text: (this.options?.[`usp_${index}_text`] || '').trim(),
      }))
      .filter(usp => usp.text)
  }

  uspIconTemplate(iconName) {
    if (!iconName || iconName === 'none') return ''
    const paths = SKIO_USP_ICON_PATHS[iconName]
    if (!paths) return ''

    // Full SVG must be injected via unsafeHTML on a wrapper — Lit cannot parse path
    // children inside html`<svg>`; they end up in the HTML namespace and do not paint.
    return html`
      <span class="skio-usp__icon" aria-hidden="true">
        ${unsafeHTML(
          `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" width="14" height="14" focusable="false">${paths}</svg>`
        )}
      </span>
    `
  }

  subscriptionUspsTemplate() {
    if (this.options?.show_usps === false) return ''

    const usps = this.subscriptionUsps()
    if (!usps.length) return ''

    return html`
      <div class="skio-usps">
        ${usps.map(
          usp => html`
            <div class="skio-usp">
              ${this.uspIconTemplate(usp.icon)}
              <span class="skio-usp__text">${usp.text}</span>
            </div>
          `
        )}
      </div>
    `
  }

  sellingPlanDropdown(group) {
    const availablePlans = group ? this.getAvailableSellingPlans(group) : []
    const hasSelection = group?.selected_selling_plan

    return html`
      <select
        class="selling-plan-dropdown ${availablePlans.length == 1 ? 'selling-plan-dropdown--one' : ''}"
        @change=${e => {
        if (e.target.value) {
          this.selectSellingPlan(e.target.value)
        }
      }}
      >
        ${group ? availablePlans.map(
          selling_plan => html` <option ?selected=${hasSelection && group.selected_selling_plan.id === selling_plan.id} value=${selling_plan.id}>${selling_plan.name}: save ${this.getSavePercentVersusOtp(selling_plan)}%</option> `
        )
        : ''}
      </select>
    `
  }

  sellingPlanButtons(group) {
    return html`
      <fieldset class="selling-plan-buttons">
        <legend class="sr-only">Select subscription interval</legend>
        ${group
        ? this.getAvailableSellingPlans(group).map(
          selling_plan => html`
                <input
                  type="radio"
                  name="selling_plan_button"
                  value="${selling_plan.id}"
                  id="selling_plan_button-${selling_plan.id}"
                  @change="${e => this.selectSellingPlan(selling_plan.id)}"
                  ?checked=${group.selected_selling_plan === selling_plan}
                />

                <label for="selling_plan_button-${selling_plan.id}"> ${selling_plan.name} </label>
              `
        )
        : ''}
      </fieldset>
    `
  }

  invalidIcon() {
    return html`
      <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#D22B2B" class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    `
  }

  validIcon() {
    return html`
      <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#0BDA51" class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    `
  }

  setupMode() {
    return html`
      <div class="setupMode">
        Skio Plan Picker
        <small>This will not appear on the live site.</small>

        <small>Key: ${this.key}</small>

        <div class="detection">${this.product ? this.validIcon() : this.invalidIcon()} Product</div>

        <div class="detection">${this.selectedVariant ? this.validIcon() : this.invalidIcon()} Selected Variant</div>

        <div class="detection">${this.form ? this.validIcon() : this.invalidIcon()} Form</div>

        <div class="detection">${this.variantInput ? this.validIcon() : this.invalidIcon()} Variant Input</div>

        <div class="detection">
          ${this.variantChanged ? this.validIcon() : this.invalidIcon()} Variant Change Detection
          <small>Please attempt to change the selected variant.</small>
        </div>

        <small>If any of these don't pass please troubleshoot using our <a target="_blank" rel="noreferrer" href="https://integrate.skio.com/troubleshooting">troubleshooting guide</a>.</small>
      </div>
    `
  }

  groupContent(group) {
    return html`
      <div class="group-content ${this.options?.layout == 'horizontal' ? '' : this.options?.show_radio_selector && this.options?.dropdownPosition == 'inside' ? '' : ''}">
        <span class="selling-plan-dropdown-label">${this.additionalFrequencyLabel()}</span>
        ${this.options?.selector_type == 'dropdown' ? this.sellingPlanDropdown(group) : ''}

      </div>
    `
  }

  showDetails() {
    return html`
      <details class="skio-details" @mouseover=${e => this.detailsMouseover()} @mouseleave=${e => this.detailsMouseleave()}>
        <summary>
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="ai ai-ArrowRepeat"
            >
              <path d="M18 2l3 3-3 3" />
              <path d="M6 22l-3-3 3-3" />
              <path d="M21 5H10a7 7 0 0 0-7 7" />
              <path d="M3 19h11a7 7 0 0 0 7-7" />
            </svg>

            How do subscriptions work?
          </span>
        </summary>
        <div class="skio-details--content">
          <ul>
            <li>
              <div class="skio-icon">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
                  />
                </svg>
              </div>
              <div class="skio-content">
                <p>Get exclusive deals</p>
                <small>Subscribe for unique discounts</small>
              </div>
            </li>
            <li>
              <div class="skio-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                </svg>
              </div>
              <div class="skio-content">
                <p>Edit your subscription anytime</p>
                <small>Edit products, delivery schedule and more</small>
              </div>
            </li>
            <li>
              <div class="skio-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path
                    fill-rule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>

              <div class="skio-content">
                <p>No commitment</p>
                <small>Easy to cancel if it's not for you</small>
              </div>
            </li>
          </ul>
          <div class="skio-details--footer">
            <a class="skio-manage-link" href="/a/account/login">Manage subscriptions</a>

            <a style="letter-spacing: 0" class="powered-by-skio" href="https://skio.com/?utm_source=eonsincshop.myshopify.com&utm_medium=details_popover" target="_blank" rel="noopener">
              Powered by
              <svg width="24" height="11" viewBox="0 0 24 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4.28399 5.78801C4.12399 5.63601 3.93599 5.50801 3.71999 5.40401C3.50399 5.30001 3.27599 5.24801 3.03599 5.24801C2.85199 5.24801 2.67999 5.28401 2.51999 5.35601C2.36799 5.42801 2.29199 5.55201 2.29199 5.72801C2.29199 5.89601 2.37599 6.01601 2.54399 6.08801C2.71999 6.16001 2.99999 6.24001 3.38399 6.32801C3.60799 6.37601 3.83199 6.44401 4.05599 6.53201C4.28799 6.62001 4.49599 6.73601 4.67999 6.88001C4.86399 7.02401 5.01199 7.20001 5.12399 7.40801C5.23599 7.61601 5.29199 7.86401 5.29199 8.15201C5.29199 8.52801 5.21599 8.84801 5.06399 9.11201C4.91199 9.36801 4.71199 9.57601 4.46399 9.73601C4.22399 9.89601 3.95199 10.012 3.64799 10.084C3.34399 10.156 3.03999 10.192 2.73599 10.192C2.24799 10.192 1.76799 10.116 1.29599 9.96401C0.831989 9.80401 0.443989 9.57201 0.131989 9.26801L1.23599 8.10401C1.41199 8.29601 1.62799 8.45601 1.88399 8.58401C2.13999 8.71201 2.41199 8.77601 2.69999 8.77601C2.85999 8.77601 3.01599 8.74001 3.16799 8.66801C3.32799 8.58801 3.40799 8.45201 3.40799 8.26001C3.40799 8.07601 3.31199 7.94001 3.11999 7.85201C2.92799 7.76401 2.62799 7.67201 2.21999 7.57601C2.01199 7.52801 1.80399 7.46401 1.59599 7.38401C1.38799 7.30401 1.19999 7.19601 1.03199 7.06001C0.871989 6.92401 0.739989 6.75601 0.635989 6.55601C0.531989 6.35601 0.479989 6.11601 0.479989 5.83601C0.479989 5.47601 0.555989 5.17201 0.707989 4.92401C0.859989 4.66801 1.05599 4.46001 1.29599 4.30001C1.53599 4.14001 1.79999 4.02401 2.08799 3.95201C2.38399 3.87201 2.67599 3.83201 2.96399 3.83201C3.41199 3.83201 3.84799 3.90401 4.27199 4.04801C4.70399 4.18401 5.06799 4.39201 5.36399 4.67201L4.28399 5.78801Z"
                  fill="black"
                />
                <path d="M12.8481 10H10.4121L8.45615 7.13201H8.42015V10H6.44015V0.928009H8.42015V6.44801H8.45615L10.3641 4.02401H12.7521L10.4481 6.72401L12.8481 10Z" fill="black" />
                <path
                  d="M15.7009 2.11601C15.7009 2.26801 15.6689 2.41201 15.6049 2.54801C15.5489 2.67601 15.4689 2.78801 15.3649 2.88401C15.2689 2.98001 15.1489 3.05601 15.0049 3.11201C14.8689 3.16801 14.7249 3.19601 14.5729 3.19601C14.2529 3.19601 13.9849 3.09201 13.7689 2.88401C13.5529 2.66801 13.4449 2.41201 13.4449 2.11601C13.4449 1.97201 13.4729 1.83601 13.5289 1.70801C13.5849 1.57201 13.6649 1.45601 13.7689 1.36001C13.8729 1.26401 13.9929 1.18801 14.1289 1.13201C14.2649 1.06801 14.4129 1.03601 14.5729 1.03601C14.7249 1.03601 14.8689 1.06401 15.0049 1.12001C15.1489 1.17601 15.2689 1.25201 15.3649 1.34801C15.4689 1.44401 15.5489 1.56001 15.6049 1.69601C15.6689 1.82401 15.7009 1.96401 15.7009 2.11601ZM13.5889 10V4.02401H15.5569V10H13.5889Z"
                  fill="black"
                />
                <path
                  d="M23.4516 6.98801C23.4516 7.47601 23.3636 7.92001 23.1876 8.32001C23.0116 8.71201 22.7716 9.04801 22.4676 9.32801C22.1636 9.60001 21.8116 9.81201 21.4116 9.96401C21.0116 10.116 20.5836 10.192 20.1276 10.192C19.6796 10.192 19.2516 10.116 18.8436 9.96401C18.4436 9.81201 18.0916 9.60001 17.7876 9.32801C17.4916 9.04801 17.2556 8.71201 17.0796 8.32001C16.9036 7.92001 16.8156 7.47601 16.8156 6.98801C16.8156 6.50001 16.9036 6.06001 17.0796 5.66801C17.2556 5.27601 17.4916 4.94401 17.7876 4.67201C18.0916 4.40001 18.4436 4.19201 18.8436 4.04801C19.2516 3.90401 19.6796 3.83201 20.1276 3.83201C20.5836 3.83201 21.0116 3.90401 21.4116 4.04801C21.8116 4.19201 22.1636 4.40001 22.4676 4.67201C22.7716 4.94401 23.0116 5.27601 23.1876 5.66801C23.3636 6.06001 23.4516 6.50001 23.4516 6.98801ZM21.5556 6.98801C21.5556 6.79601 21.5236 6.60801 21.4596 6.42401C21.3956 6.24001 21.3036 6.08001 21.1836 5.94401C21.0636 5.80001 20.9156 5.68401 20.7396 5.59601C20.5636 5.50801 20.3596 5.46401 20.1276 5.46401C19.8956 5.46401 19.6916 5.50801 19.5156 5.59601C19.3396 5.68401 19.1916 5.80001 19.0716 5.94401C18.9596 6.08001 18.8716 6.24001 18.8076 6.42401C18.7516 6.60801 18.7236 6.79601 18.7236 6.98801C18.7236 7.18001 18.7516 7.36801 18.8076 7.55201C18.8716 7.73601 18.9636 7.90401 19.0836 8.05601C19.2036 8.20001 19.3516 8.31601 19.5276 8.40401C19.7036 8.49201 19.9076 8.53601 20.1396 8.53601C20.3716 8.53601 20.5756 8.49201 20.7516 8.40401C20.9276 8.31601 21.0756 8.20001 21.1956 8.05601C21.3156 7.90401 21.4036 7.73601 21.4596 7.55201C21.5236 7.36801 21.5556 7.18001 21.5556 6.98801Z"
                  fill="black"
                />
              </svg>
            </a>
          </div>
        </div>
      </details>
    `
  }

  // !SECTION: Element Templates

  render() {
    if (!this.viable() || this.options?.layout === 'hidden') {
      return this.debug ? this.setupMode() : ''
    }

    if (this.selectedVariant.selling_plan_allocations.length === 0 && !this.options?.show_without_subscription) {
      return this.debug ? this.setupMode() : ''
    }

    if (this.availableSellingPlanGroups?.length == 0 && !this.options?.show_without_subscription) return

    return html`
      ${this.debug ? this.setupMode() : null}

      <fieldset class="skio-plan-picker" role="radiogroup" aria-labelledby="skio-plan-picker-legend">
        ${this.deliveryInfo()
        ? html`<div class="skio-delivery-info">${unsafeHTML(this.deliveryInfo())}</div>`
        : ''}
        <legend id="skio-plan-picker-legend" class="${!this.options?.show_legend ? 'sr-only' : ''}">${unsafeHTML(this.options?.legend_content)}</legend>

        ${!this.product.requires_selling_plan
        ? html`
              <div
                class="group-container ${this.selectedSellingPlanGroup == null ? 'group-container--selected' : ''} ${!this.options?.onetime_first ? 'group-container--last' : ''}"
                @click=${() => this.selectSellingPlanGroup(null)}
              >
                <input
                  id="one-time-${this.key}"
                  class="group-input"
                  name="skio-group-${this.key}"
                  type="radio"
                  value="One time"
                  ?checked=${!this.selectedSellingPlanGroup}
                  @change=${() => this.selectSellingPlanGroup(null)}
                />

                <label class="group-label" for="one-time-${this.key}">
                  <div class="group-topline">
                    ${this.options?.layout == 'horizontal' ? '' : this.options?.show_radio_selector ? this.radioTemplate() : ''}

                    <div class="group-title">
                      <div class="group-title-inner">
                        ${this.options?.onetime_title ? this.options?.onetime_title : 'One time'}
                        ${this.otpSavingsSpan()}
                      </div>
                    </div>

                    <div class="skio-price" aria-live="polite">
                      ${this.options?.show_compare_price && this.getOneTimeStrikeoutCompareCents()
            ? html`<s aria-hidden="true">Was ${this.money(this.getOneTimeStrikeoutCompareCents())}</s>`
            : ''}
                      <span class="skio-price__current ${this.isOneTimePriceReduced() ? 'skio-price__current--sale' : ''}">${this.money(
                        this.getSkioDiscountBasisCents()
                      )}</span>
                      ${this.unitPrice(this.getSkioDiscountBasisCents(), this.selectedVariant.title)
            ? html`<span class="skio-unit-price">${this.unitPrice(this.getSkioDiscountBasisCents(), this.selectedVariant.title)}</span> `
            : ''}
                    </div>
                  </div>
                </label>
              </div>
            `
        : ''}
        ${this.availableSellingPlanGroups?.length
        ? this.availableSellingPlanGroups.map(
          (group, index) => html`
                <div class="group-container ${this.selectedSellingPlanGroup == group ? 'group-container--selected' : ''} ${this.subscriptionBadgeText() ? 'group-container--has-badge' : ''}">
                  ${this.subscriptionBadgeTemplate()}
                  <input
                    id="group-${index}-${this.key}"
                    class="group-input"
                    name="skio-group-${this.key}"
                    type="radio"
                    value="${group.id}"
                    @change=${() => this.selectSellingPlanGroup(group)}
                    ?checked=${this.selectedSellingPlanGroup == group}
                  />

                  <label class="group-label" for="group-${index}-${this.key}">
                    <div class="group-topline">
                      ${this.options?.layout == 'horizontal' ? '' : this.options?.show_radio_selector ? this.radioTemplate() : ''}

                      <div class="group-title">
                      <div class="group-title-inner">
                        ${group.name !== 'Prepaid' && this.options?.subscription_title
              ? this.options?.subscription_title
              : group.name == 'Prepaid' && this.options?.prepaid_title
                ? this.options?.prepaid_title
                : group.name}
                        ${this.groupSavingsSpan(group)}
                        ${this.tooltipContent ? html`<span class="skio-tooltip" tabindex="0" aria-describedby="skio-tooltip-${this.key}-${index}">
                          <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1zM7 4h2v2H7V4zm0 3h2v5H7V7z"/></svg>
                          <span id="skio-tooltip-${this.key}-${index}" class="skio-tooltip-text" role="tooltip">${this.tooltipContent}</span>
                        </span>` : ''}
                        </div>

                        ${this.options?.selector_type == 'button' ? this.sellingPlanButtons(group) : ''} ${this.additionalContentText()}
                      </div>

                      <div class="skio-price" aria-live="polite">
                        ${this.options?.show_compare_price && this.getSubscriptionStrikeoutCompareCents(group)
              ? html`<s aria-hidden="true">Was ${this.money(this.getSubscriptionStrikeoutCompareCents(group))}</s>`
              : ''}
                        <span class="skio-price__current ${this.isSubscriptionGroupPriceReduced(group) ? 'skio-price__current--sale' : ''}">${this.getGroupPrice(
                          group,
                          true
                        )}</span>
                        ${this.unitPrice(this.getGroupPrice(group, false), this.selectedVariant.title)
              ? html`<span class="skio-unit-price">${this.unitPrice(this.getGroupPrice(group, false), this.selectedVariant.title)}</span> `
              : ''}
                      </div>
                    </div>

                    ${this.subscriptionUspsTemplate()}
                    ${this.options?.layout == 'vertical' && this.options?.dropdownPosition == 'inside' ? this.groupContent(group) : ''}
                  </label>
                </div>
                ${this.selectedSellingPlanGroup == group ? (this.options?.layout == 'horizontal' || this.options?.dropdownPosition == 'underneath' ? this.groupContent(group) : '') : ''}
              `
        )
        : ''}
        ${this.options?.show_details == true ? this.showDetails() : ''}
      </fieldset>
    `
  }

  async fetchRules() {
    if (sessionStorage.getItem('skio-discount-rules')) {
      return JSON.parse(sessionStorage.getItem('skio-discount-rules'))
    } else {
      const rules = await fetch(`https://api.skio.com/storefront-http/get-rules-by-domain-or-hostname?domain=${window?.Shopify?.shop}`)
        .then(response => response.json())
        .then(response => {
          return response.rules.filter(rule => rule.type !== 'surpriseDelight').sort((a, b) => a.minQuantityToDiscount - b.minQuantityToDiscount)
        })

      sessionStorage.setItem('skio-discount-rules', JSON.stringify(rules))
      return rules
    }
  }

  eligibleItemCount(rule) {
    const eligibleQuantity = rule?.productVariantIds.some(gid => gid.includes(this.selectedVariant.id)) ? this.quantity : 0

    if (!this.cart?.items) return eligibleQuantity

    const cartItems = Number(
      this.cart?.items.reduce(
        (aggregate, item) =>
          rule?.productVariantIds.some(gid => gid.includes(item.id) && item.selling_plan_allocation && gid.includes(this.selectedVariant.id)) ? aggregate + item.quantity : aggregate,
        0
      )
    )

    return cartItems + eligibleQuantity
  }

  getRule() {
    let largestMinQuantity = {
      value: -1,
      index: -1,
    }

    this.rules.forEach((rule, index) => {
      if (rule.code && largestMinQuantity.value < rule.minQuantityToDiscount) {
        if (rule.minQuantityToDiscount <= this.eligibleItemCount(rule)) {
          largestMinQuantity.value = rule.minQuantityToDiscount
          largestMinQuantity.index = index
        }
      }
    })

    this.rule = largestMinQuantity.index > -1 ? this.rules[largestMinQuantity.index] : null
  }

  bindCartEvents() {
    document.addEventListener('CartUpdated', event => {
      this.cart = event.detail
    })
  }

  bindFormEvents() {
    // First try to find form by specified form_id
    this.form = document.querySelector(`#${this.options?.form_id}`)

    // If no form found by ID, search through parents and page
    if (!this.form) {
      this.form = this.findProductForm()
    }

    if (!this.form) {
      this.error('No valid product form found')
      return
    }

    // Add debug styling if debug mode is enabled
    if (this.debug) {
      this.form.style.borderStyle = 'solid'
      this.form.style.borderWidth = '4px'
      this.form.style.borderImage = 'repeating-linear-gradient(-55deg,#000,#000 20px,#ffb101 20px,#ffb101 40px)10'
    }

    // Ensure form has an ID
    if (!this.form.getAttribute('id')) {
      this.form.setAttribute('id', `skio-form-${this.product.id}`)
    }

    // Set form attribute on selling plan input
    const sellingPlanInput = this.querySelector('input[name="selling_plan"]')
    if (sellingPlanInput) {
      sellingPlanInput.setAttribute('form', this.form.getAttribute('id'))
    }

    this.variantInput = this.form.querySelector('[name="id"]')
    if (!this.variantInput) this.variantInput = document.querySelector(`[name="id"][form="${this.options?.form_id}"]`)

    if (this.variantInput) {
      this.variantInput.addEventListener('change', e => {
        this.selectedVariant = this.product.variants.find(variant => variant.id == e.target.value)
        this.variantChanged = true
      })
      // this.form.addEventListener('change', e => {
      //   this.selectedVariant = this.product.variants.find(variant => variant.id == this.variantInput.value)
      //   this.variantChanged = true
      // })
    }

    const $quantityInput = this.form.querySelector('[name="quantity"]')

    if ($quantityInput) {
      this.quantity = Number($quantityInput.value)
      $quantityInput.addEventListener('input', () => {
        this.quantity = Number($quantityInput.value)
      })
    }

    let skio = this
    // Example variantChanged event dispatch:
    // document.dispatchEvent( new CustomEvent("variantChanged", { detail: { variantId: variant.id } }) );
    document.addEventListener('variantChanged', function (e) {
      let variantId = e.detail.variantId
      let variant = skio.product.variants.find(x => x.id == variantId)
      if (variant) skio.selectedVariant = variant
      else skio.log('Unable to find variant with id: ', variantId)
      this.variantChanged = true
      skio.requestUpdate()
    })
  }

  findProductForm() {
    // First try finding form through parent elements
    const formFromParent = this.findFormThroughParents()
    if (formFromParent) return formFromParent

    // If no form found through parents, look for any valid product forms on page
    const allProductForms = this.getAllProductForms()
    return allProductForms[0] || null
  }

  findFormThroughParents() {
    let currentElement = this
    let depth = 0
    const maxDepth = 5

    while (currentElement.parentElement && depth < maxDepth) {
      const forms = Array.from(currentElement.querySelectorAll('form'))
      const validForm = forms.find(form => this.isValidProductForm(form))

      if (validForm) return validForm

      currentElement = currentElement.parentElement
      depth++
    }

    return null
  }

  getAllProductForms() {
    return Array.from(document.forms).filter(form => {
      const hasVariantId = this.getVariantId(form)
      return this.isValidProductForm(form) && hasVariantId
    })
  }

  isValidProductForm(form) {
    const hasCartAction = form.getAttribute('action')?.includes('/cart/add')
    const hasSubmitButton = !!form.querySelector('button, [type="submit"]')
    return hasCartAction && hasSubmitButton
  }

  getVariantId(form) {
    // Try getting ID from FormData first
    const formData = new FormData(form)
    const idFromFormData = formData.get('id')
    if (idFromFormData) return Number(idFromFormData)

    // Fallback to finding input element
    const idInput = form.querySelector('[name="id"]')
    return idInput ? Number(idInput.value) : null
  }

  detailsMouseover() {
    let details = this.renderRoot.querySelector('.skio-details')
    let summary = this.renderRoot.querySelector('.skio-details summary')
    if (!details.hasAttribute('open') && this.showDetailsHover == false) {
      summary.click()
      this.showDetailsHover = true
    }
  }

  detailsMouseleave() {
    let details = this.renderRoot.querySelector('.skio-details')
    let summary = this.renderRoot.querySelector('.skio-details summary')
    if (details.hasAttribute('open') && this.showDetailsHover == true) {
      summary.click()
      this.showDetailsHover = false
    }
  }

  firstUpdated() {
    // Safari fix: Apply color scheme after first render with a delay
    // This ensures stylesheets are fully loaded and computed
    setTimeout(() => {
      this.applyColorScheme();
    }, 0);
  }

  updated(changed) {
    if (!this.viable()) return

    // Apply color scheme if it changed or if product changed
    if (changed.has('colorScheme') || (changed.has('product') && this.product)) {
      this.applyColorScheme()
    }

    if (changed.has('product') && this.product) {
      this.key = this.key ? this.key : this.product.id
    }

    if (changed.has('selectedVariant') && this.selectedVariant) {
      const filteredSellingPlanGroups = this.product.selling_plan_groups.filter(
        selling_plan_group =>
          selling_plan_group.app_id === 'SKIO' && !selling_plan_group.name.toLowerCase().includes('hidden-') && !selling_plan_group.name.toLowerCase().includes('dynamic box subscription')
      )

      //update availableSellingPlanGroups based on skioSellingPlanGroups and selectedVariant.id
      this.availableSellingPlanGroups = filteredSellingPlanGroups.filter(selling_plan_group =>
        selling_plan_group.selling_plans.some(selling_plan =>
          this.selectedVariant.selling_plan_allocations.some(selling_plan_allocation => selling_plan_allocation.selling_plan_id === selling_plan.id)
        )
      )

      if (this.options?.combine_groups) {
        this.availableSellingPlanGroups = [
          {
            name: this.options?.combined_group_name,
            selling_plans: this.availableSellingPlanGroups.flatMap(group => group.selling_plans),
            id: 'combined_group',
            app_id: 'SKIO',
          },
        ]
      }

      // TODO: Select proper group depending on what selling plan is selected

      //update selectedSellingPlan value
      if (this.availableSellingPlanGroups?.length) {
        const url = new URL(window.location.href)
        const urlSelectedSellingPlanId = url.searchParams.get('selling_plan')

        //update each group with a default selected_selling_plan
        this.availableSellingPlanGroups.forEach(group => {
          const availableSellingPlans = this.getAvailableSellingPlans(group)

          const urlSelectedSellingPlan = availableSellingPlans.find(plan => plan.id == urlSelectedSellingPlanId)
          const nameSelectedSellingPlan = availableSellingPlans.find(plan => plan.name === this.selectedSellingPlan?.name)
          const defaultSellingPlan =
            this.options?.default_subscription && this.options.default_subscription.trim() !== ''
              ? availableSellingPlans.find(plan => plan.name.toLowerCase().includes(this.options.default_subscription.toLowerCase()))
              : null

          group.selected_selling_plan = urlSelectedSellingPlan || nameSelectedSellingPlan || defaultSellingPlan || availableSellingPlans[0]

          const isAnyPlanSelected = urlSelectedSellingPlan || nameSelectedSellingPlan || defaultSellingPlan

          group.selected = !!isAnyPlanSelected
        })

        if ((!this.variantChanged && this.options?.start_onetime == false) || this.product.requires_selling_plan == true || urlSelectedSellingPlanId || this.selectedSellingPlan) {
          let selectedSellingPlanGroup = this.availableSellingPlanGroups.find(group => group.selected) || this.availableSellingPlanGroups[0]
          let selectedSellingPlanId = selectedSellingPlanGroup.selected_selling_plan.id
          this.selectSellingPlan(selectedSellingPlanId)
        } else {
          this.selectSellingPlanGroup(null)
        }
      } else {
        this.selectSellingPlanGroup(null)
      }
    }

    if (changed.has('selectedSellingPlan')) {
      //dispatch CustomEvent to tell that this specific plan picker was updated, and pass the selectedSellingPlan
      const event = new CustomEvent(`skio::update-selling-plan`, {
        bubbles: true,
        composed: true,
        detail: {
          variant: this.selectedVariant,
          sellingPlan: this.selectedSellingPlan,
          key: this.key,
        },
      })

      this.dispatchEvent(event)

      this.dispatchEvent(
        new CustomEvent('change', {
          detail: { value: this.selectedSellingPlan?.id },
        })
      )
    }

    this.updateForm()
    this.updateExternalPrice()

    if (!this.disableUrl) {
      this.updateURLParams()
    }

    if (changed.has('quantity')) {
      this.getRule()
    }

    if (changed.has('cart')) {
      this.getRule()
    }

    this.updateExternalElements()
    this.updateTooltipContent()
  }

  updateExternalElements() {
    document.querySelectorAll(`[skio-price][skio-key="${this.key}"]`).forEach(el => {
      el.innerHTML = this.price(this.selectedSellingPlan)
    })

    document.querySelectorAll(`[skio-subscription-content]`).forEach(el => {
      el.style.display = this.selectedSellingPlan ? 'block' : 'none'
    })
  }

  // SECTION: Utility Functions
  log(...args) {
    args.unshift(`%c[skio plan picker][${this.key}]`, 'color: #8770f2;')
    // console.log.apply(console, args)
  }

  error(...args) {
    args.unshift(`%c [skio plan picker][${this.key}]`, 'color: #ff0000')
    console.error.apply(console, args)
  }

  appendOrdinalSuffix(num) {
    const j = num % 10,
      k = num % 100
    if (j == 1 && k != 11) {
      return num + 'st'
    }
    if (j == 2 && k != 12) {
      return num + 'nd'
    }
    if (j == 3 && k != 13) {
      return num + 'rd'
    }
    return num + 'th'
  }

  viable() {
    const errors = []

    const sellingPlanInput = this.querySelector('input[name=selling_plan]')
    if (!sellingPlanInput) {
      errors.push('Missing selling plan input')
    }

    if (!this.product) {
      errors.push('No product found. Please pass a product or productHandle to the skio-plan-picker component.')
    }
    if (!this.selectedVariant) {
      errors.push('No variant found. Please pass a product or productHandle to the skio-plan-picker component.')
    }
    if (!this.form) {
      errors.push('No form found. Please add a form_id to the plan picker through the Shopify customizer or ensure that the element is in a form that has an input with name="id".')
    }
    if (!this.variantInput) {
      errors.push('No variant input found. Please add a form_id to the plan picker through the Shopify customizer or ensure that the element is in a form that has an input with name="id"')
    }

    if (errors.length == 0) return true

    this.error('Errors', errors)
    return false
  }

  getAvailableSellingPlans(group) {
    let availableSellingPlans = group.selling_plans.filter(selling_plan =>
      this.selectedVariant.selling_plan_allocations.some(selling_plan_allocation => selling_plan_allocation.selling_plan_id === selling_plan.id)
    )

    return availableSellingPlans
  }

  // !SECTION: Utility Functions

  // Update selected selling plan group; called on click of group-container element
  selectSellingPlanGroup(group) {
    this.selectedSellingPlanGroup = group
    this.selectedSellingPlan = group?.selected_selling_plan
  }

  // Update selected selling plan; called on change of skio-frequency select element
  selectSellingPlan(selling_plan_id) {
    const selectedGroup = this.availableSellingPlanGroups.find(group => group.selling_plans.some(plan => plan.id == selling_plan_id))
    const selectedSellingPlan = selectedGroup.selling_plans.find(plan => plan.id == selling_plan_id)

    selectedGroup.selected_selling_plan = selectedSellingPlan
    this.selectedSellingPlanGroup = selectedGroup
    this.selectedSellingPlan = selectedSellingPlan
  }

  updateExternalPrice() {
    if (!this.options?.external_price_selector) return;

    document.querySelectorAll(this.options.external_price_selector).forEach(el => {
      // Exclude cart drawer and cart page price elements from Skio updates
      // These prices are managed by Shopify's cart system and should not be overwritten
      if (el.closest('.cart-drawer') !== null || el.closest('.cart-item') !== null || el.closest('.cart') !== null || el.closest('cart-items') !== null) {
        return;
      }

      el.innerHTML = this.selectedSellingPlan ? this.price(this.selectedSellingPlan) : this.money(this.getSkioDiscountBasisCents());
    })
  }

  additionalFrequencyLabel() {
    if (!this.options?.additional_frequency_label || this.options?.additional_frequency_label == '') return

    return unsafeHTML(this.options?.additional_frequency_label)
  }

  additionalContentText() {
    if (!this.options?.additional_subscription_content || this.options?.additional_subscription_content == '') return

    return html`
      <div class="group-content-additional">
        ${unsafeHTML(
      this.options?.additional_subscription_content
        .replaceAll(
          '[discount]',
          this.options?.discount_format === 'absolute' ? this.money(this.discount(this.selectedSellingPlan).absolute) : this.discount(this.selectedSellingPlan).percent + '%'
        )
        .replaceAll('[future_price_adjustments]', this.postCheckoutDiscountsText(this.selectedSellingPlan) || '')
    )}
      </div>
    `
  }

  loadVariantDeliveryInfo() {
    const attr = this.getAttribute('variantdeliveryinfo')
    if (!attr) return

    try {
      const parsed = JSON.parse(attr)
      if (Array.isArray(parsed)) {
        this.variantDeliveryInfo = parsed.reduce((acc, item) => {
          if (item?.id && item?.content) acc[item.id] = item.content
          return acc
        }, {})
      } else if (parsed && typeof parsed === 'object') {
        this.variantDeliveryInfo = parsed
      }
    } catch (error) {
      this.error('Failed to parse variant delivery info', error)
      this.variantDeliveryInfo = {}
    }
  }

  deliveryInfo() {
    const variantId = this.selectedVariant?.id
    if (variantId && this.variantDeliveryInfo?.[variantId]) {
      return this.variantDeliveryInfo[variantId]
    }

    const deliveryField = this.selectedVariant?.metafields?.details?.delivery_info
    if (!deliveryField) return ''

    if (typeof deliveryField === 'string') return deliveryField
    if (typeof deliveryField?.value === 'string') return deliveryField.value

    return ''
  }

  /**
   * Extracts number and unit from variant name
   * Handles formats like "10kg", "8 bags", "6 x 80g"
   * For "6 x 80g" format: uses first number (6) as quantity, extracts unit from second pair (g)
   * @param {string} variantName - The variant name/title
   * @returns {Object|null} - { number: number, unit: string } or null if not found
   */
  parseVariantUnit(variantName) {
    if (!variantName || typeof variantName !== 'string') return null

    const variantTitle = variantName.toLowerCase()
    const variantTitleOriginal = variantName

    // Condition 1: variant_title contains 'g' AND variant.title contains 'x'
    if (variantTitle.includes('g') && variantTitleOriginal.includes('x')) {
      // Split by 'x' and take first part as units_count
      const parts = variantTitleOriginal.split('x')
      if (parts.length > 0 && parts[0].trim()) {
        const unitsCount = parseFloat(parts[0].trim())
        if (!isNaN(unitsCount) && unitsCount > 0) {
          // Use packagingtype metafield for unit, fallback to empty string
          const unit = this.product?.metafields?.my_fields?.packagingtype?.value || ''
          return {
            number: unitsCount,
            unit: unit,
            isMultiplier: true // Flag to indicate this is a multiplier format
          }
        }
      }
    }

    // Condition 2: variant_title contains 'bag' OR 'bags'
    if (variantTitle.includes('bag') || variantTitle.includes('bags')) {
      // Split by space and take first word as units_count
      const parts = variantTitleOriginal.split(' ')
      if (parts.length > 0 && parts[0].trim()) {
        const unitsCount = parseFloat(parts[0].trim())
        if (!isNaN(unitsCount) && unitsCount > 0) {
          return {
            number: unitsCount,
            unit: 'bag',
            isBag: true
          }
        }
      }
    }

    // Condition 3: variant_title contains 'kg'
    if (variantTitle.includes('kg')) {
      // Remove 'kg' to get units_count
      const unitsCountStr = variantTitleOriginal.replace(/kg/gi, '').trim()
      const unitsCount = parseFloat(unitsCountStr)
      if (!isNaN(unitsCount) && unitsCount > 0) {
        return {
          number: unitsCount,
          unit: 'kg',
          isKg: true
        }
      }
    }

    // Condition 4: variant_title contains 'g' (fallback)
    if (variantTitle.includes('g')) {
      // Remove 'g' to get units_count
      const unitsCountStr = variantTitleOriginal.replace(/g/gi, '').trim()
      const unitsCount = parseFloat(unitsCountStr)
      if (!isNaN(unitsCount) && unitsCount > 0) {
        return {
          number: unitsCount,
          unit: 'kg',
          isGrams: true
        }
      }
    }

    return null
  }

  /**
   * Calculates and formats unit price
   * @param {number} price - The total price in cents
   * @param {string} variantName - The variant name to extract unit info
   * @returns {string|null} - Formatted unit price like "$12.50/kg" or null if cannot calculate
   */
  unitPrice(price, variantName) {
    const unitInfo = this.parseVariantUnit(variantName)
    if (!unitInfo || !unitInfo.number || unitInfo.number <= 0) return null

    let unit = unitInfo.unit
    let unitPriceCents

    const productTitle = this.product?.title || ''

    // Handle multiplier format (e.g., "6 x 80g")
    if (unitInfo.isMultiplier) {
      // Price per unit = price / units_count
      unitPriceCents = price / unitInfo.number
      // If unit is empty (no packagingtype metafield), try to determine from product title
      if (!unit) {
        // Apply product title adjustments as fallback
        if (productTitle.toLowerCase().includes('wet dog food')) {
          unit = 'tray'
        } else if (productTitle.toLowerCase().includes('wet cat food') || productTitle.toLowerCase().includes('tins')) {
          unit = 'tin'
        } else if (productTitle.toLowerCase().includes('pouches') || productTitle.toLowerCase().includes('krunchies')) {
          unit = 'Pouch'
        } else {
          // If still no unit, return null
          return null
        }
      }
    }
    // Handle bag format
    else if (unitInfo.isBag) {
      // Price per bag = price / units_count
      unitPriceCents = price / unitInfo.number
    }
    // Handle kg format
    else if (unitInfo.isKg) {
      // Convert units_count to grams
      const unitsInGrams = 1000 * unitInfo.number
      // Price per kg = (price * 1000) / units_in_grams
      unitPriceCents = (price * 1000) / unitsInGrams
    }
    // Handle grams format (fallback)
    else if (unitInfo.isGrams) {
      // Price per kg = (price * 1000) / units_count
      unitPriceCents = (price * 1000) / unitInfo.number
    }
    else {
      // Fallback to simple division
      unitPriceCents = price / unitInfo.number
    }

    // Adjust unit based on product title (applies to all formats, overriding metafield if needed)
    // If product is "Wet Dog Food", use "Tray"
    if (productTitle.toLowerCase().includes('wet dog food')) {
      unit = 'tray'
    }
    // If product is "Wet Cat Food" or contains "tins", use "Tin"
    else if (productTitle.toLowerCase().includes('wet cat food') || productTitle.toLowerCase().includes('tins')) {
      unit = 'tin'
    }
    // If product title contains "Pouches", change unit to "Pouch"
    else if (productTitle.toLowerCase().includes('pouches')) {
      unit = 'pouch'
    }

    return `${this.money(unitPriceCents)}/${unit}`
  }

  // SECTION: Discount Functions
  /**
   * Automatic discount % from product tags such as `sticker:15% Off` (matches theme “hot” badges).
   * `product.tags` may be an array (from Liquid `| json`) or a comma-separated string (`/products/handle.js`).
   */
  autoDiscountPercentFromTags() {
    let tagList = this.product?.tags
    if (tagList == null) return 0
    if (typeof tagList === 'string') {
      tagList = tagList
        .split(',')
        .map(t => t.trim())
        .filter(Boolean)
    }
    if (!Array.isArray(tagList) || tagList.length === 0) return 0

    let best = 0
    for (const tag of tagList) {
      if (typeof tag !== 'string') continue
      if (!tag.toLowerCase().startsWith('sticker:')) continue
      const m = tag.match(/(\d+(?:\.\d+)?)\s*%/i)
      if (m) {
        const n = parseFloat(m[1])
        if (!Number.isNaN(n) && n > 0 && n < 100) best = Math.max(best, n)
      }
    }
    return best
  }

  /**
   * Cents: one-time offer price and the basis for subscription / Skio percentage discounts.
   * If compare_at is set above price (manual sale), uses variant.price. Otherwise applies sticker % to catalog.
   */
  getSkioDiscountBasisCents(variant = this.selectedVariant) {
    if (!variant) return 0
    const catalog = variant.price
    if (variant.compare_at_price && variant.compare_at_price > catalog) return catalog
    const pct = this.autoDiscountPercentFromTags()
    if (pct > 0) return Math.round((catalog * (100 - pct)) / 100)
    return catalog
  }

  /** List / compare cents for the one-time “Was” line, or null if none. */
  getOneTimeStrikeoutCompareCents(variant = this.selectedVariant) {
    if (!variant) return null
    const catalog = variant.price
    if (variant.compare_at_price && variant.compare_at_price > catalog) return variant.compare_at_price
    const pct = this.autoDiscountPercentFromTags()
    if (pct > 0) {
      const offer = Math.round((catalog * (100 - pct)) / 100)
      if (offer < catalog) return catalog
    }
    return null
  }

  /**
   * One-time savings vs strikeout list (compare-at or catalog when sticker applies).
   * Only when {@link getOneTimeStrikeoutCompareCents} is set — same cases as the OTP “Was” price.
   */
  getOtpSavingsDisplay() {
    const strikeout = this.getOneTimeStrikeoutCompareCents()
    const otp = this.getSkioDiscountBasisCents()
    if (!this.selectedVariant || strikeout == null || strikeout <= otp) return null
    const absoluteCents = strikeout - otp
    if (absoluteCents <= 0) return null
    const percent = Math.round((absoluteCents / strikeout) * 100)
    return { percent, absoluteCents }
  }

  otpSavingsSpan() {
    const versus = this.getOtpSavingsDisplay()
    if (!versus) return html``

    const discountToken =
      this.options?.discount_format === 'absolute' ? this.money(versus.absoluteCents) : versus.percent + '%'

    const templateStr = this.options?.onetime_savings_text || this.options?.discount_text || 'Save [discount]'

    const inner = unsafeHTML(
      templateStr.replaceAll('[discount]', discountToken).replaceAll('[future_price_adjustments]', '')
    )

    return html` <span class="savings ${this.options?.discount_style}"> ${inner} </span> `
  }

  /** Plan used for group savings copy (matches default selected plan when present). */
  getRepresentativeSellingPlanForGroup(group) {
    return group?.selected_selling_plan || this.getAvailableSellingPlans(group)?.[0] || null
  }

  /** List / MSRP cents for “total savings” copy: compare-at when on sale, otherwise catalog variant price. */
  getReferenceListCentsForFinalSavings(variant = this.selectedVariant) {
    if (!variant) return 0
    const price = variant.price
    const compare = variant.compare_at_price
    if (compare && compare > price) return compare
    return price
  }

  /**
   * Single headline savings: subscription vs reference list (includes sticker + subscription in one % or £ amount).
   */
  getFinalSavingsVersusListForPlan(selling_plan) {
    const list = this.getReferenceListCentsForFinalSavings()
    if (!selling_plan || !Number.isFinite(list) || list <= 0) return null
    const sub = this.price(selling_plan, false)
    if (!Number.isFinite(sub) || sub >= list) return null
    const absoluteCents = list - sub
    const percent = Math.round((absoluteCents / list) * 100)
    return percent > 0 ? { percent, absoluteCents } : null
  }

  /** Same as {@link getFinalSavingsVersusListForPlan} using the group’s displayed subscription price. */
  getFinalSubscriptionSavingsVsList(group) {
    const list = this.getReferenceListCentsForFinalSavings()
    const sub = this.getGroupPrice(group, false)
    if (!Number.isFinite(list) || list <= 0 || !Number.isFinite(sub) || sub >= list) return null
    const absoluteCents = list - sub
    const percent = Math.round((absoluteCents / list) * 100)
    return percent > 0 ? { percent, absoluteCents } : null
  }

  /** One-time row: sale / sticker / compare-at so the shown price is below catalog list. */
  isOneTimePriceReduced() {
    const v = this.selectedVariant
    if (!v) return false
    if (v.compare_at_price && v.compare_at_price > v.price) return true
    return this.getSkioDiscountBasisCents(v) < v.price
  }

  /** Subscription row: Skio plan price below reference list (same basis as “Save X%” badge). */
  isSubscriptionGroupPriceReduced(group) {
    return this.getFinalSubscriptionSavingsVsList(group) != null
  }

  /**
   * Subscription vs one-time price only (basis matches OTP row / {@link getSkioDiscountBasisCents}).
   * Excludes extra “vs list” savings from compare-at; those belong on the one-time row, not here.
   */
  getSavePercentVersusOtp(selling_plan) {
    const otp = this.getSkioDiscountBasisCents()
    if (!selling_plan || !Number.isFinite(otp) || otp <= 0) return 0
    const sub = this.price(selling_plan, false)
    if (!Number.isFinite(sub) || sub >= otp) return 0
    const absoluteCents = otp - sub
    const percent = Math.round((absoluteCents / otp) * 100)
    return percent > 0 ? percent : 0
  }

  groupSavingsSpan(group) {
    const plan = this.getRepresentativeSellingPlanForGroup(group)
    const versus = this.getFinalSubscriptionSavingsVsList(group)
    if (!versus) return html``

    const discountToken =
      this.options?.discount_format === 'absolute' ? this.money(versus.absoluteCents) : versus.percent + '%'

    const inner = unsafeHTML(
      (this.options?.discount_text || 'Save [discount]')
        .replaceAll('[discount]', discountToken)
        .replaceAll('[future_price_adjustments]', plan ? this.postCheckoutDiscountsText(plan) || '' : '')
    )

    return html` <span class="savings ${this.options?.discount_style}"> ${inner} </span> `
  }

  discount(selling_plan) {
    if (!selling_plan) return { percent: 0, amount: 0 }
    return this.getDiscountFromPriceAdjustment(selling_plan, selling_plan.price_adjustments[0])
  }

  postCheckoutPriceAdjustments(selling_plan) {
    const { price_adjustments } = selling_plan
    const postCheckoutPriceAdjustments = price_adjustments.filter(({ position }) => position !== 1)
    const discounts = postCheckoutPriceAdjustments.map(price_adjustment => this.getDiscountFromPriceAdjustment(selling_plan, price_adjustment))
    return discounts
  }

  postCheckoutDiscountsText(sellingPlan = this.selectedSellingPlan) {
    if (!sellingPlan || !this.options?.future_price_adjustments_text || this.future_price_adjustments_text == '') return

    const postCheckoutPriceAdjustments = this.postCheckoutPriceAdjustments(sellingPlan)
    if (!postCheckoutPriceAdjustments.length) return

    return postCheckoutPriceAdjustments.map((discount, index) =>
      this.options?.future_price_adjustments_text
        .replaceAll('[discount]', this.options?.discount_format === 'absolute' ? this.money(discount.absolute) : discount.percent + '%')
        .replaceAll('[order_count]', index + 1)
        .replaceAll('[order_count_ordinal]', this.appendOrdinalSuffix(index + 1))
    )
  }

  getDiscountFromPriceAdjustment(selling_plan, price_adjustment) {
    const discount = {
      percent: 0,
      amount: 0,
      absolute: 0,
    }

    let multiplier = 1

    let sellingPlanGroup = this.product.selling_plan_groups.find(group => group.selling_plans.some(plan => plan.id == selling_plan.id))

    if (sellingPlanGroup?.name === 'Prepaid') {
      const str = selling_plan.name // replace with your string
      const intervalDate = /\b\d+\s*(days|weeks|months|years)\b/gi
      const intervalDateMatches = str.match(intervalDate)

      if (intervalDateMatches?.length) {
        const intervals = intervalDateMatches[0].match(/\d+/g)
        multiplier = intervals[0] / (intervals[1] || 1)
        multiplier = multiplier > 1 ? multiplier : 1
      }
    }

    const catalogPrice = this.selectedVariant.price
    const compareAtPrice =
      this.selectedVariant.compare_at_price && this.selectedVariant.compare_at_price > catalogPrice
        ? this.selectedVariant.compare_at_price
        : catalogPrice
    const basisPrice = this.getSkioDiscountBasisCents()

    switch (price_adjustment.value_type) {
      case 'percentage':
        discount.percent = price_adjustment.value
        discount.absolute = Math.round((basisPrice * price_adjustment.value) / 100.0)
        discount.amount = Math.round((basisPrice * price_adjustment.value) / 100.0)
        break
      case 'fixed_amount':
        discount.percent = basisPrice ? Math.round(((price_adjustment.value * 1.0) / basisPrice) * 100.0) : 0
        discount.absolute = price_adjustment.value
        discount.amount = price_adjustment.value
        break
      case 'price':
        discount.percent = Math.round((((compareAtPrice * multiplier - price_adjustment.value) * 1.0) / (compareAtPrice * multiplier)) * 100.0)
        discount.absolute = compareAtPrice * multiplier - price_adjustment.value
        discount.amount = basisPrice - price_adjustment.value
        break
    }

    return discount
  }

  /**
   * Formats a number of cents into a currency string using Shopify format string.
   *
   * https://help.shopify.com/en/manual/international/pricing/currency-formatting#currency-formatting-options
   *
   * Originally from: https://gist.github.com/stewartknapman/8d8733ea58d2314c373e94114472d44c
   *
   * @param cents - The number of cents to format.
   * @param formatString - The format string to use.
   * @returns The formatted currency string.
   */
  money(cents, formatString = this.moneyFormat) {
    const placeholderRegex = /{{\s*(\w+)\s*}}/

    /**
     * Formats a number of cents into a currency string using the provided
     * precision, thousands separator, and decimal separator.
     * @param number - The number of cents to format.
     * @param precision - The number of decimal places to include.
     * @param thousands - The character to use as the thousands separator.
     * @param decimal - The character to use as the decimal separator.
     * @returns The formatted currency string.
     */
    function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
      if (isNaN(number) || number == null) {
        return '0'
      }

      const numString = (number / 100.0).toFixed(precision)
      const parts = numString.split('.')
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands)
      const cents = parts[1] ? decimal + parts[1] : ''
      return dollars + cents
    }

    return formatString.replace(placeholderRegex, (match, placeholder) => {
      switch (placeholder) {
        case 'amount':
          // Ex.	1,134.65
          return formatWithDelimiters(cents, 2)
        case 'amount_no_decimals':
          // Ex. 1,135
          return formatWithDelimiters(cents, 0)
        case 'amount_with_comma_separator':
          // Ex. 1.134,65
          return formatWithDelimiters(cents, 2, '.', ',')
        case 'amount_no_decimals_with_comma_separator':
          // Ex. 1.135
          return formatWithDelimiters(cents, 0, '.', ',')
        case 'amount_with_apostrophe_separator':
          // Ex. 1'134.65
          return formatWithDelimiters(cents, 2, "'", '.')
        case 'amount_no_decimals_with_space_separator':
          // Ex. 1 135
          return formatWithDelimiters(cents, 0, ' ')
        case 'amount_with_space_separator':
          // 1 134,65
          return formatWithDelimiters(cents, 2, ' ', ',')
        case 'amount_with_period_and_space_separator':
          // 1 134.65
          return formatWithDelimiters(cents, 2, ' ', '.')
        default:
          return match
      }
    })
  }

  // !SECTION: Discount Functions
  price(selling_plan, formatted = true) {
    const base = this.getSkioDiscountBasisCents()
    if (this.rule) {
      return formatted
        ? this.money(base - this.discount(selling_plan).amount - base * (this.rule.discountAmount / 100))
        : base - this.discount(selling_plan).amount - base * (this.rule.discountAmount / 100)
    }

    return formatted ? this.money(base - this.discount(selling_plan).amount) : base - this.discount(selling_plan).amount
  }

  /**
   * Gets the price for a subscription group
   * If a selling plan is selected, uses that price
   * Otherwise, shows a default 10% discount
   * @param {Object} group - The selling plan group
   * @param {boolean} formatted - Whether to return formatted string or number
   * @returns {string|number} - Price formatted or in cents
   */
  getGroupPrice(group, formatted = true) {
    const plan = group?.selected_selling_plan || this.getAvailableSellingPlans(group)?.[0]
    if (plan) {
      return this.price(plan, formatted)
    }

    const defaultDiscountPercent = 10
    const base = this.getSkioDiscountBasisCents()
    const defaultDiscountAmount = base * (defaultDiscountPercent / 100)
    const defaultPrice = base - defaultDiscountAmount

    return formatted ? this.money(defaultPrice) : defaultPrice
  }

  /**
   * Strikeout reference for subscription row:
   * OTP price before OTP discount, with subscription discount applied.
   */
  getSubscriptionStrikeoutCompareCents(group) {
    const plan = group?.selected_selling_plan || this.getAvailableSellingPlans(group)?.[0]
    const subscriptionPrice = this.getGroupPrice(group, false)
    if (!Number.isFinite(subscriptionPrice)) return null

    const otpCheckoutPrice = this.getSkioDiscountBasisCents()
    const otpBeforeDiscount = this.getOneTimeStrikeoutCompareCents() || this.selectedVariant?.price
    if (!Number.isFinite(otpBeforeDiscount)) return null
    if (!Number.isFinite(otpCheckoutPrice)) return null

    // If OTP is not discounted, compare subscription directly against OTP checkout price.
    const hasOtpDiscount = otpBeforeDiscount > otpCheckoutPrice
    if (!hasOtpDiscount) {
      return otpCheckoutPrice > subscriptionPrice ? Math.round(otpCheckoutPrice) : null
    }

    if (!plan?.price_adjustments?.length) return null

    const firstAdjustment = plan.price_adjustments.find(({ position }) => position === 1) || plan.price_adjustments[0]
    if (!firstAdjustment) return null

    let strikeout = otpBeforeDiscount
    switch (firstAdjustment.value_type) {
      case 'percentage':
        strikeout = otpBeforeDiscount - Math.round((otpBeforeDiscount * firstAdjustment.value) / 100.0)
        break
      case 'fixed_amount':
        strikeout = otpBeforeDiscount - firstAdjustment.value
        break
      case 'price':
        strikeout = firstAdjustment.value
        break
    }

    strikeout = Math.round(strikeout)
    return strikeout > subscriptionPrice ? strikeout : null
  }

  // Updates element data to be registered by forms
  updateForm() {
    let $sellingPlan = this.querySelector('input[name=selling_plan]')

    if ($sellingPlan) {
      $sellingPlan.value = this.selectedSellingPlan ? this.selectedSellingPlan.id : ''
      $sellingPlan.dispatchEvent(new Event('change'))
    }

    // Also update selling plan input in sticky add-to-cart bar
    this.updateStickyBarForm()
  }

  // Updates selling plan input in sticky add-to-cart bar form
  updateStickyBarForm() {
    const stickyBarForm = document.querySelector('.sticky-atc-bar__form')
    if (!stickyBarForm) return

    let stickySellingPlanInput = stickyBarForm.querySelector('input[name="selling_plan"]')

    // Create input if it doesn't exist
    if (!stickySellingPlanInput) {
      stickySellingPlanInput = document.createElement('input')
      stickySellingPlanInput.type = 'hidden'
      stickySellingPlanInput.name = 'selling_plan'
      stickyBarForm.appendChild(stickySellingPlanInput)
    }

    // Update the value
    stickySellingPlanInput.value = this.selectedSellingPlan ? this.selectedSellingPlan.id : ''
    stickySellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }))
  }

  // Observes for sticky bar form to appear dynamically and updates it
  observeStickyBarForm() {
    // Check if sticky bar form already exists
    if (document.querySelector('.sticky-atc-bar__form')) {
      this.updateStickyBarForm()
      return
    }

    // Watch for sticky bar form to be added to DOM
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Check if the added node is the sticky bar form or contains it
            if (node.classList?.contains('sticky-atc-bar__form') ||
              node.querySelector?.('.sticky-atc-bar__form')) {
              this.updateStickyBarForm()
              // Optionally disconnect after finding it
              observer.disconnect()
              return
            }
          }
        }
      }
    })

    // Start observing the document body for changes
    observer.observe(document.body, {
      childList: true,
      subtree: true
    })

    // Store observer for cleanup if needed
    this.stickyBarObserver = observer
  }

  // SECTION: Additional Functionality
  updateURLParams() {
    const url = new URL(window.location.href)

    if (this.selectedSellingPlan) {
      url.searchParams.set('selling_plan', this.selectedSellingPlan.id)
      window.history.replaceState({}, '', url.href)
    } else {
      url.searchParams.delete('selling_plan')
      window.history.replaceState({}, '', url.href)
    }
  }

  // Runs a fetch request to add the selectedVariant to the cart with the passed quantity and selectedSellingPlan
  addToCart(quantity) {
    const items = [
      {
        id: this.selectedVariant.id,
        quantity: quantity,
        ...(this.selectedSellingPlan && {
          selling_plan: this.selectedSellingPlan?.id,
        }),
      },
    ]

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items,
      }),
    })
      .then(response => response.json())
      .then(response => {
        this.log('Added item to cart: ', response)
        //dispatch CustomEvent to tell document that an item was added to cart
        const event = new CustomEvent(`skio::added-to-cart`, {
          bubbles: true,
          composed: true,
          detail: {
            response,
            key: this.key,
          },
        })

        this.dispatchEvent(event)
      })
      .catch(error => {
        this.error(`SKIO ${this.key} error adding item to cart: `, error)
      })
  }

  fetchProduct = handle => {
    return fetch(`/products/${handle}.js`)
      .then(response => response.json())
      .then(product => {
        this.product = product
        this.selectedVariant = product.variants[0]

        return product
      })
  }

  replacePlaceholders(template, sellingPlan = this.selectedSellingPlan) {
    if (!template) return ''

    const versus = sellingPlan ? this.getFinalSavingsVersusListForPlan(sellingPlan) : null
    const discount = this.discount(sellingPlan)
    const discountText = versus
      ? this.options?.discount_format === 'absolute'
        ? this.money(versus.absoluteCents)
        : versus.percent + '%'
      : this.options?.discount_format === 'absolute'
        ? this.money(discount.absolute || discount.amount)
        : (discount.percent > 0 ? discount.percent : 0) + '%'

    const futureDiscounts = this.postCheckoutDiscountsText(sellingPlan) || []
    const futureDiscountsText = futureDiscounts.join(', ')

    return template
      .replaceAll('[discount]', discountText)
      .replaceAll('[future_price_adjustments]', futureDiscountsText)
  }

  updateTooltipContent() {
    const template = this.options?.tooltip_content || '';
    let plan = this.selectedSellingPlan;
    if (!plan && this.availableSellingPlanGroups?.length) {
      const firstGroup = this.availableSellingPlanGroups[0];
      plan = firstGroup.selected_selling_plan || firstGroup.selling_plans?.[0] || null;
    }
    this.tooltipContent = this.replacePlaceholders(template, plan);
  }

  // SECTION: Color Scheme Functions
  usesProductColorScheme() {
    return this.options?.use_product_color_scheme === true
  }

  shouldIgnoreThemeColorScheme() {
    if (this.hasAttribute('skio-block')) {
      return true
    }

    if (this.dataset?.ignoreProductColorScheme === 'true') {
      return true
    }

    const ignoredAncestor = this.closest?.('[data-ignore-product-color-scheme="true"]')
    return !!ignoredAncestor
  }

  clearThemeColorScheme() {
    const classesToRemove = Array.from(this.classList).filter(className =>
      className.startsWith('color-')
    )
    classesToRemove.forEach(className => this.classList.remove(className))
  }

  /**
   * Maps product color to color scheme class (matching scrumbles-colours.liquid logic)
   * @param {string} color - The color value from product metafield
   * @returns {string} - The color scheme class name (e.g., 'scheme-8')
   */
  mapColorToScheme(color) {
    if (!color) return 'scheme-1';

    const normalizedColor = color.toLowerCase().trim();
    const colorMap = {
      'blue': 'scheme-8',
      'red': 'scheme-9',
      'green': 'scheme-10',
      'orange': 'scheme-11',
      'teal': 'scheme-12',
      'purple': 'scheme-13',
      'yellow': 'scheme-14'
    };

    return colorMap[normalizedColor] || 'scheme-1';
  }

  /**
   * Applies color scheme class to the component when the block setting is enabled.
   * When disabled, block colour settings are used as-is across all products.
   */
  applyColorScheme() {
    if (this.shouldIgnoreThemeColorScheme() || !this.usesProductColorScheme()) {
      this.clearThemeColorScheme()
      requestAnimationFrame(() => {
        this.propagateCssVariablesToShadowRoot()
      })
      return
    }

    let scheme = this.colorScheme

    if (!scheme && this.product?.metafields?.details?.product_color) {
      scheme = this.mapColorToScheme(this.product.metafields.details.product_color)
    }

    if (!scheme && document.body?.dataset?.productColor) {
      scheme = this.mapColorToScheme(document.body.dataset.productColor)
    }

    if (!scheme) {
      let parent = this.parentElement
      let depth = 0
      while (parent && depth < 10) {
        const parentClasses = Array.from(parent.classList)
        const colorClass = parentClasses.find(cls => cls.startsWith('color-'))
        if (colorClass) {
          scheme = colorClass.replace('color-', '')
          break
        }
        parent = parent.parentElement
        depth++
      }
    }

    if (scheme) {
      this.clearThemeColorScheme()
      this.classList.add(`color-${scheme}`)

      requestAnimationFrame(() => {
        this.propagateCssVariablesToShadowRoot()
      })

      this.requestUpdate()
    } else {
      requestAnimationFrame(() => {
        this.propagateCssVariablesToShadowRoot()
      })
    }
  }

  /**
   * Safari fix: Explicitly propagate CSS custom properties into the Shadow DOM.
   * Safari has issues with CSS variable inheritance from dynamically-added classes
   * on custom elements. We inject a style element directly into the shadow root.
   */
  propagateCssVariablesToShadowRoot() {
    const themeCssVars = [
      '--color-foreground',
      '--color-background',
      '--color-primary',
      '--color-secondary-background',
      '--color-border',
      '--color-button',
      '--color-button-text',
      '--color-badge-sale',
      '--color-badge-sale-text',
      '--color-subtext',
    ];

    const hostStyle = getComputedStyle(this);
    let computedStyle = null;

    if (hostStyle.getPropertyValue('--color-foreground').trim()) {
      computedStyle = hostStyle;
    }

    if (!computedStyle) {
      let parent = this.parentElement;
      let depth = 0;
      while (parent && depth < 10) {
        const parentStyle = getComputedStyle(parent);
        if (parentStyle.getPropertyValue('--color-foreground').trim()) {
          computedStyle = parentStyle;
          break;
        }
        parent = parent.parentElement;
        depth++;
      }
    }

    if (!computedStyle) return;

    const cssVarValues = {};

    for (const varName of themeCssVars) {
      const value = computedStyle.getPropertyValue(varName);
      if (value && value.trim()) {
        cssVarValues[varName] = value.trim();
      }
    }

    for (const varName of SKIO_CSS_VARS) {
      const value = hostStyle.getPropertyValue(varName);
      if (value && value.trim()) {
        cssVarValues[varName] = value.trim();
      }
    }

    const options = this.options || {};
    const optionSkioMap = {
      '--skio-group-border-radius': options.group_border_radius != null ? `${options.group_border_radius}px` : null,
      '--skio-group-border-width': options.group_border_width != null ? `${options.group_border_width}px` : null,
      '--skio-group-border-color': options.group_border_color,
      '--skio-group-border-selected-color': options.group_border_selected_color,
      '--skio-group-background-color': options.group_background_color,
      '--skio-group-background-selected-color': options.selected_group_background_color,
      '--skio-group-text-color': options.group_text_color,
      '--skio-group-text-selected-color': options.group_selected_text_color,
      '--skio-discount-color': options.discount_color,
      '--skio-discount-text-color': options.discount_text_color,
      '--skio-button-plan-selector-width': options.button_plan_selector_width != null ? `${options.button_plan_selector_width}px` : null,
      '--skio-tooltip-background-color': options.tooltip_background_color,
      '--skio-tooltip-text-color': options.tooltip_text_color,
      '--skio-usp-color': options.usp_color,
    };

    for (const [varName, value] of Object.entries(optionSkioMap)) {
      if (value && !cssVarValues[varName]) {
        cssVarValues[varName] = value;
      }
    }

    // Theme color scheme overrides (matches skio-app-block.liquid); only when block setting is on.
    if (this.usesProductColorScheme() && !this.shouldIgnoreThemeColorScheme() && cssVarValues['--color-foreground']) {
      const fg = cssVarValues['--color-foreground'];
      const bg = cssVarValues['--color-background'];
      const secondaryBg = cssVarValues['--color-secondary-background'];

      cssVarValues['--skio-group-border-selected-color'] = `rgb(${fg})`;
      cssVarValues['--skio-group-text-color'] = `rgb(${fg})`;
      cssVarValues['--skio-group-text-selected-color'] = `rgb(${fg})`;
      cssVarValues['--skio-usp-color'] = `rgb(${fg})`;

      if (bg) {
        cssVarValues['--skio-group-background-color'] = `rgb(${bg})`;
        cssVarValues['--skio-tooltip-background-color'] = `rgb(${fg})`;
        cssVarValues['--skio-tooltip-text-color'] = `rgb(${bg})`;
      }

      if (isTransparentCssColor(cssVarValues['--skio-group-background-selected-color']) && secondaryBg) {
        cssVarValues['--skio-group-background-selected-color'] = `rgb(${secondaryBg})`;
      }
    }

    for (const varName in cssVarValues) {
      this.style.setProperty(varName, cssVarValues[varName]);
    }

    if (this.shadowRoot) {
      const existingStyle = this.shadowRoot.querySelector('#skio-color-scheme-vars');
      if (existingStyle) {
        existingStyle.remove();
      }

      let cssText = ':host {\n';
      for (const varName in cssVarValues) {
        cssText += '  ' + varName + ': ' + cssVarValues[varName] + ';\n';
      }
      cssText += '}\n';

      cssText += '* {\n';
      for (const varName in cssVarValues) {
        cssText += '  ' + varName + ': ' + cssVarValues[varName] + ';\n';
      }
      cssText += '}\n';

      const styleEl = document.createElement('style');
      styleEl.id = 'skio-color-scheme-vars';
      styleEl.textContent = cssText;
      this.shadowRoot.prepend(styleEl);
    }
  }
  // !SECTION: Color Scheme Functions

  // !SECTION: Additional Functionality
}

if (!customElements.get('skio-plan-picker')) {
  customElements.define('skio-plan-picker', SkioPlanPicker)
}

if (window) window.SkioPlanPicker = SkioPlanPicker
